import { formatDate, formatTime } from "../../../../helper_functions/date_time_formats"
export default class VoyageData {
    constructor(id, theyrId, routeId, routeTheyrId, vesselId, vesselTheyrId, companyId, description, startTime, status, options,route,vessel,createdAt) {
        this.id = id
        this.theyrId = theyrId
        this.routeId = routeId
        this.routeTheyrId = routeTheyrId
        this.vesselId = vesselId
        this.vesselTheyrId = vesselTheyrId
        this.companyId = companyId
        this.description = description
        this.startTime = startTime
        this.status = status
        this.options = options
        this.route = route
        this.vessel = vessel
        this.createdAt = createdAt
    }


    get startTimeStamp() {
        return formatDate(this.startTime)
    }

    get startDate() {
        return formatTime(this.startTime)
    }

    get createdAtDate() {
        return formatDate(this.createdAt)
    }

    get createdAtTime() {
        return formatTime(this.createdAt)
    }
}
